const SyncButton = () => {
  // Composant désactivé - utiliser npm run sync:auto à la place
  return null;
};

export default SyncButton;

/* Code désactivé pour éviter les warnings ESLint
import React, { useState, useEffect } from 'react';
import { syncService } from '../services/api';
import axios from 'axios';

const SyncButton = ({ onSyncComplete }) => {
  const [loading, setLoading] = useState(false);
  const [loadingChars, setLoadingChars] = useState(false);
  const [result, setResult] = useState(null);
  const [resultChars, setResultChars] = useState(null);
  const [error, setError] = useState(null);
  const [apiEnabled, setApiEnabled] = useState(false);
  const [configLoading, setConfigLoading] = useState(true);

  // Vérifier si l'API est activée au chargement
  useEffect(() => {
    const checkApiStatus = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:4000/api'}/config`);
        setApiEnabled(response.data.apiEnabled);
      } catch (err) {
        console.error('Erreur lors de la vérification de l\'état de l\'API:', err);
        setApiEnabled(false);
      } finally {
        setConfigLoading(false);
      }
    };

    checkApiStatus();
  }, []);

  const handleSync = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await syncService.syncTournois();
      setResult(response.data);

      // Callback pour recharger les données dans le parent
      if (onSyncComplete) {
        setTimeout(() => onSyncComplete(), 500);
      }
    } catch (err) {
      if (err.response?.status === 503) {
        setError('L\'API Start.gg n\'est pas activée. Lance le backend avec: npm run dev:api');
      } else if (err.response?.status === 500) {
        // Message d'erreur personnalisé du backend
        const errorMsg = err.response?.data?.error || 'Erreur lors de la synchronisation';
        const errorCode = err.response?.data?.code;

        if (errorCode === 502 || errorCode === 504) {
          setError(`⚠️ ${errorMsg}\n\nL'API Start.gg semble avoir un problème temporaire. Réessayez dans quelques minutes.`);
        } else if (errorCode === 429) {
          setError(`⏱️ ${errorMsg}\n\nTrop de requêtes envoyées. Attendez 1-2 minutes avant de réessayer.`);
        } else {
          setError(errorMsg);
        }
      } else {
        setError(err.response?.data?.error || err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSyncPersonnages = async () => {
    setLoadingChars(true);
    setError(null);
    setResultChars(null);

    try {
      const response = await syncService.syncPersonnages();
      setResultChars(response.data);

      // Callback pour recharger les données dans le parent
      if (onSyncComplete) {
        setTimeout(() => onSyncComplete(), 500);
      }
    } catch (err) {
      if (err.response?.status === 503) {
        setError('L\'API Start.gg n\'est pas activée. Lance le backend avec: npm run dev:api');
      } else if (err.response?.status === 500) {
        // Message d'erreur personnalisé du backend
        const errorMsg = err.response?.data?.error || 'Erreur lors de la synchronisation';
        const errorCode = err.response?.data?.code;

        if (errorCode === 502 || errorCode === 504) {
          setError(`⚠️ ${errorMsg}\n\nL'API Start.gg semble avoir un problème temporaire. Réessayez dans quelques minutes.`);
        } else if (errorCode === 429) {
          setError(`⏱️ ${errorMsg}\n\nTrop de requêtes envoyées. Attendez 1-2 minutes avant de réessayer.`);
        } else {
          setError(errorMsg);
        }
      } else {
        setError(err.response?.data?.error || err.message);
      }
    } finally {
      setLoadingChars(false);
    }
  };

  // Composant désactivé - utiliser npm run sync:auto à la place
  return null;

  /* Code désactivé
  // Ne pas afficher si l'API n'est pas activée
  if (configLoading) {
    return null; // Ou un loader si souhaité
  }

  if (!apiEnabled) {
    return null; // Ne rien afficher si l'API est désactivée
  }

  return (
    <div className="sync-container">
      <div className="d-flex gap-2 mb-3">
        <button
          onClick={handleSync}
          disabled={loading || loadingChars}
          className="btn btn-primary"
          title="Synchroniser les tournois depuis Start.gg"
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Synchronisation...
            </>
          ) : (
            <>
              <i className="bi bi-arrow-repeat me-2"></i>
              Synchroniser les tournois
            </>
          )}
        </button>

        <button
          onClick={handleSyncPersonnages}
          disabled={loading || loadingChars}
          className="btn btn-secondary"
          title="Synchroniser les personnages de tous les joueurs depuis Start.gg"
        >
          {loadingChars ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Synchronisation...
            </>
          ) : (
            <>
              <i className="bi bi-controller me-2"></i>
              Synchroniser les personnages
            </>
          )}
        </button>
      </div>

      {result && (
        <div className="alert alert-success mt-3" role="alert">
          <strong>✅ Tournois synchronisés !</strong>
          <ul className="mb-0 mt-2">
            <li>{result.stats.tournois} tournois synchronisés</li>
            <li>{result.stats.smasheurs} joueurs mis à jour</li>
          </ul>
        </div>
      )}

      {resultChars && (
        <div className="alert alert-success mt-3" role="alert">
          <strong>✅ Personnages synchronisés !</strong>
          <ul className="mb-0 mt-2">
            <li>{resultChars.stats.success} / {resultChars.stats.total} joueurs synchronisés</li>
            {resultChars.stats.errors > 0 && <li className="text-warning">{resultChars.stats.errors} erreurs</li>}
          </ul>
        </div>
      )}

      {error && (
        <div className="alert alert-danger mt-3" role="alert">
          <strong>❌ Erreur de synchronisation</strong>
          <p className="mb-0 mt-2" style={{ whiteSpace: 'pre-line' }}>{error}</p>
        </div>
      )}

      <p className="text-muted mt-2 small">
        <i className="bi bi-info-circle me-1"></i>
        Cette fonctionnalité nécessite que le backend soit lancé avec l'API Start.gg activée
      </p>
    </div>
  );
};

export default SyncButton;
*/